import React from 'react'
import { format } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

import get from 'lodash/get'

import { ListRow } from '@labsavvyapp/ui-components'
import style from './ClientNote.module.css'

export default function ClientNote({ data }) {
  const formatInTimeZone = (date, fmt, tz) =>
    format(utcToZonedTime(date, tz), fmt, { timeZone: tz })

  return (
    <ListRow className={style.row}>
      <div className={style.nameDateColumn}>
        <div>{get(data, 'createdBy.name.display')}</div>
        <div>
          {data.createdAt &&
            formatInTimeZone(
              data.createdAt,
              `MM/dd/yyyy 'at' h:mm a`,
              Intl.DateTimeFormat().resolvedOptions().timeZone,
            )}
        </div>
      </div>

      <div
        data-test="lab-report-note"
        className={style.note}
        dangerouslySetInnerHTML={{
          __html: data.body?.replace('<figure>&nbsp;</figure>', '<hr>') || '',
        }}
      />
    </ListRow>
  )
}
